<template src="./list.html"></template>

<script>

import SchoolService from 'Services/SchoolService';

export default {
  data() {
    return {
      schoolJPs: [],
      i18n: 2,
      videoId: null,
    };
  },

  created() {
    this.list();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 100) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 100)}...`;
      }

      return '';
    },

    ready(event) {
      this.player = event.target;
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      const paramsJP = {
        type_contact: 3,
        take: 8,
        i18n: this.i18n,
      };
      SchoolService.listTop(paramsJP)
        .then((response) => {
          this.schoolJPs = response.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
};
li {
    margin-bottom: -70px;
}
</style>
